import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "../components/App";

document
  .querySelectorAll<HTMLElement>("[data-react-component='App']")
  .forEach((el) =>
    createRoot(el).render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )
  );
